import { User } from "oidc-client-ts";
import { appAuthUrl, appRealm } from "./constants";

const onSigninCallback = (_user: User | void): void => {
     window.history.replaceState(
         {},
         document.title,
         window.location.pathname
     )
}

export const oidcConfig: any = {
  authority: `${appAuthUrl}/realms/${appRealm}`,
  client_id: "wildfire-time-tracking-app",
  redirect_uri: window.location.href,
  post_logout_redirect_uri: `${window.location.origin}/logged-out`,
  pkce_method: "S256",
  extraQueryParams: {
    kc_idp_hint: "oidc"
  },
  accessTokenExpiringNotificationTimeInSeconds: (3*60),   // Number of seconds before the token expires to trigger the `tokenExpiring` event .. the defualt is 60 sec
  onSigninCallback
};